export const REQUEST_FETCH_CLIENT = 'clients/REQUEST_FETCH_CLIENT';
export const REQUEST_FETCH_CLIENTS = 'clients/REQUEST_FETCH_CLIENTS';
export const REQUEST_FETCH_CLIENT_ENTITY = 'clients/REQUEST_FETCH_CLIENT_ENTITY';
export const REQUEST_ADD_TO_GROUP = 'clients/REQUEST_ADD_TO_GROUP';
export const REQUEST_MOVE_TO_GROUP = 'clients/REQUEST_MOVE_TO_GROUP';
export const REQUEST_ARCHIVE_CLIENTS = 'clients/REQUEST_ARCHIVE_CLIENTS';
export const REQUEST_RESTORE_CLIENTS = 'clients/REQUEST_RESTORE_CLIENTS';
export const REQUEST_DELETE_FROM_GROUP = 'clients/REQUEST_DELETE_FROM_GROUP';
export const REQUEST_ADD_CLIENT_ENTITY = 'clients/REQUEST_ADD_CLIENT_ENTITY';
export const REQUEST_DELETE_CLIENT_ITEMS = 'clients/REQUEST_DELETE_CLIENT_ITEMS';
export const REQUEST_DELETE_CLIENT_ENTITY = 'clients/REQUEST_DELETE_CLIENT_ENTITY';
export const REQUEST_UPLOAD_GROUP_AVATAR = 'clients/REQUEST_UPLOAD_GROUP_AVATAR';

// assign
export const REQUEST_DASHBOARDS = 'client/REQUEST_DASHBOARDS';
export const REQUEST_ASSIGN_CLIENT = 'client/REQUEST_ASSIGN_CLIENT';
export const REQUEST_UNASSIGN_CLIENT = 'client/REQUEST_UNASSIGN_CLIENT';
export const REQUEST_ASSIGN_GROUP = 'client/REQUEST_ASSIGN_GROUP';
export const REQUEST_UNASSIGN_GROUP = 'client/REQUEST_UNASSIGN_GROUP';
export const REQUEST_GROUP_ENTITY = 'clients/REQUEST_GROUP_ENTITY';
export const REQUEST_GROUP_ENTITY_ASSIGNMENTS = 'clients/REQUEST_GROUP_ENTITY_ASSIGNMENTS';
export const REQUEST_CLIENT_PERSONAL_ENTITY = 'clients/REQUEST_CLIENT_PERSONAL_ENTITY';
export const REQUEST_INVITE_CLIENT = 'clients/REQUEST_INVITE_CLIENT';
export const REQUEST_DELETE_PERSONAL_ENTITY = 'clients/REQUEST_DELETE_PERSONAL_ENTITY';
export const REQUEST_CREATE_PERSONAL_ENTITY = 'client/REQUEST_CREATE_PERSONAL_ENTITY';
export const REQUEST_UPDATE_CLIENT_INFO = 'clients/REQUEST_UPDATE_CLIENT_INFO';
export const REQUEST_UPLOAD_CLIENT_AVATAR = 'clients/REQUEST_UPLOAD_CLIENT_AVATAR';
export const REQUEST_NOTIFICATIONS = 'clients/REQUEST_NOTIFICATIONS';
export const REQUEST_CLIENTS_PERFORMANCE = 'clients/REQUEST_CLIENTS_PERFORMANCE';
export const REQUEST_ARCHIVE_TEMPLATE = 'clients/REQUEST_ARCHIVE_TEMPLATE';
export const REQUEST_RESTORE_TEMPLATE = 'clients/REQUEST_RESTORE_TEMPLATE';
export const REQUEST_ARCHIVE_ASSIGNMENT = 'clients/REQUEST_ARCHIVE_ASSIGNMENT';
export const REQUEST_RESTORE_ASSIGNMENT = 'clients/REQUEST_RESTORE_ASSIGNMENT';
